module.exports = __webpack_public_path__ + "img/upload.39eb6b96.svg";